import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { theme } from '@styles/theme';
import { Button, Input, Card, CardContent, DevTools } from '@components/index';
import { AuthLayout } from '@layouts/index';
import { useAuth } from '@state/index';
const Form = styled.form `
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
`;
const ErrorMessage = styled.div `
  color: ${theme.colors.status.error};
  font-size: ${theme.typography.fontSize.sm};
  text-align: center;
  padding: ${theme.spacing.sm};
  background-color: ${theme.colors.status.error}20;
  border-radius: ${theme.borderRadius.md};
`;
const SubmitButton = styled(Button) `
  margin-top: ${theme.spacing.sm};
`;
export function LoginPage() {
    const navigate = useNavigate();
    const { login, error, clearError, isLoading } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const handleSubmit = async (e) => {
        e.preventDefault();
        clearError();
        try {
            await login(email, password);
            navigate('/');
        }
        catch {
            // Error is handled by the auth context
        }
    };
    const handleFillCredentials = useCallback((userEmail, userPassword) => {
        setEmail(userEmail);
        setPassword(userPassword);
    }, []);
    return (_jsxs(AuthLayout, { children: [_jsx(Card, { children: _jsx(CardContent, { children: _jsxs(Form, { onSubmit: handleSubmit, children: [error && _jsx(ErrorMessage, { children: error }), _jsx(Input, { label: "Email", type: "email", value: email, onChange: (e) => setEmail(e.target.value), placeholder: "Enter your email", required: true, autoComplete: "email" }), _jsx(Input, { label: "Password", type: "password", value: password, onChange: (e) => setPassword(e.target.value), placeholder: "Enter your password", required: true, autoComplete: "current-password" }), _jsx(SubmitButton, { type: "submit", fullWidth: true, loading: isLoading, disabled: isLoading, children: "Sign In" })] }) }) }), _jsx(DevTools, { onFillCredentials: handleFillCredentials })] }));
}
